<template>
	<div class="content">
		<div class="container-fluid">
			<div class="row">
				<div class="col-md-12">
					<div class="nav-bar box-horizontal mb-0">
						<i class="material-icons d-block text-secondary mr-2 pointer p-2" @click="$router.go(-1)">arrow_back</i>
						<div class="flex-1">
							<h3 class="m-0">Edit Pelanggan : {{nama}}</h3>
						</div>
					</div>
					<div class="card">
						<div class="card-body">
							<div class="row">
								<div class="col-md-12">
									<div class="form-group">
										<div class="form-group">
											<label class="bmd-label-floating">Nama</label>
											<input type="text" class="form-control" placeholder="Nama Area..." v-model="nama">
										</div>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12">
									<div class="form-group">
										<div class="form-group">
											<label class="bmd-label-floating">ID PPOE</label>
											<input type="text" class="form-control" placeholder="Nama Area..." v-model="ppoe">
										</div>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12">
									<div class="form-group">
										<div class="form-group">
											<label class="bmd-label-floating">Mikrotik</label>
											<select class="form-control" id="exampleFormControlSelect1" placeholder="Pilih Resto..."  v-model="mikrotikPilih">
												<option value="" selected disabled>{{mikrotikSelectedName}}</option>
												<option value="" selected disabled>--------------------</option>
												<option v-for="(u, index) in mikrotik" :value="u.id" >{{u.nama}}</option>
											</select>
										</div>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12">
									<div class="form-group">
										<div class="form-group">
											<label class="bmd-label-floating">Nomer WA</label>
											<input type="text" class="form-control" placeholder="Nama Area..." v-model="wa">
										</div>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12">
									<div class="form-group">
										<div class="form-group">
											<label class="bmd-label-floating">Tanggal Tagihan <strong v-show="false">{{tanggal}}</strong></label>
											<vuejs-datepicker :format="customFormatter" placeholder="Ganti Tanggal..." style="width:100%" v-model="tanggal"></vuejs-datepicker>
										</div>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12">
									<div class="form-group">
										<div class="form-group">
											<label class="bmd-label-floating">Area</label>
											<select class="form-control" id="exampleFormControlSelect1" placeholder="Pilih Resto..."  v-model="areaPilih">
												<option value="" selected disabled>{{areaNama}}</option>
												<option v-for="(u, index) in area" :value="u.id" >{{u.nama}}</option>
											</select>
										</div>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12">
									<div class="form-group">
										<div class="form-group">
											<label class="bmd-label-floating">Tarif</label>
											<select class="form-control" id="exampleFormControlSelect1" placeholder="Pilih Resto..."  v-model="tarifPilih">
												<option value="" selected disabled>{{tarifNama}}</option>
												<option v-for="(u, index) in tarif" :value="u.id" >{{u.nama}}</option>
											</select>
										</div>
									</div>
								</div>
							</div>

							<div class="form-group">
								<label class="bmd-label-floating">Biaya Tambahan 1</label>
								<div class="row col-md-12 mb-3">
									<input type="text" class="form-control col-md-6" placeholder="Rincian Baiaya 1...." v-model="rincian1">
									<input type="number" class="form-control col-md-6" placeholder="Biaya Tambahan 1...." v-model="biaya1">
								</div>
								<label class="bmd-label-floating">Biaya Tambahan 2</label>
								<div class="row col-md-12">
									<input type="text" class="form-control col-md-6" placeholder="Rincian Baiaya 2...." v-model="rincian2">
									<input type="number" class="form-control col-md-6" placeholder="Biaya Tambahan 2" v-model="biaya2">
								</div>
							</div>
							<div class="row">
								<div class="col-md-12">
									<div class="form-group">
										<div class="form-group">
											<label class="bmd-label-floating">Diskon</label>
											<input type="number" class="form-control" placeholder="Diskon..." v-model="diskon">
										</div>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12">
									<div class="form-group">
										<div class="form-group">
											<label class="bmd-label-floating">Latitude (-8.xxxxxx)</label>
											<input type="text" class="form-control" placeholder="Latitude..." v-model="lat">
										</div>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12">
									<div class="form-group">
										<div class="form-group">
											<label class="bmd-label-floating">Longitude (113.xxxxxx)</label>
											<input type="text" class="form-control" placeholder="Latitude..." v-model="lng">
										</div>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12">
									<div class="form-group">
										<div class="form-group">
											<label class="bmd-label-floating">Alamat</label>
											<input type="text" class="form-control" placeholder="alamat..." v-model="alamat">
										</div>
									</div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12">
									<div class="form-group">
										<div class="form-group">
											<label class="bmd-label-floating">Modem</label>
											<input type="text" class="form-control" placeholder="Mis : TotoN200, TendaN300, tplink wr840" v-model="modem"> 
										</div>
									</div>
								</div>
							</div>
							<div class="row" v-show="false">
								<div class="col-md-12">
									<div class="form-group">
										<div class="form-group">
											<label class="bmd-label-floating">Password (opsional : jika ini diisi bisa digunakan pada aplikasi pelanggan.  <a href="https://play.google.com/store/apps/details?id=com.rtrw.myuser" target="_blank">Link Playstore</a> )</label>
											<input type="password" class="form-control" placeholder="Password..." v-model="password">
										</div>
									</div>
								</div>
							</div>
							<div class="row" v-show="false">
								<div class="col-md-12">
									<div class="form-group">
										<div class="form-group">
											<label class="bmd-label-floating">Konfirmasi Password</label>
											<input type="password" class="form-control" placeholder="Konfirmasi Password..." v-model="cpassword">
										</div>
									</div>
								</div>
							</div>

							<div class="row">
								<div class="col-md-12">
								<div class="form-group">
									<button class="btn btn-primary" @click="Simpan">Update</button>
								</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import Vue from 'vue'
import vuejsDatepicker from 'vuejs-datepicker'
import moment from 'moment'
import inter from '@/globalFunc/Interface' 
import { RedisSession } from '@/globalFunc/redis';
import myGlobal from '@/globalFunc/myGlobal' 

Vue.use(moment)

export default {
	components: { 
		vuejsDatepicker,
		moment,
	}, 
  	data() {
		return {
			title: "Detail Servis",
			id: '',
			nama: '',
			ppoe: '',
			wa: '',
			area: [],
			mikrotik:[],
			tarif: [],
			tanggal: '',
			areaPilih: '',
			areaNama: '',
			tarifPilih: '',
			tarifNama: '',
			rincian1: '',
			biaya1: '',
			rincian2: '',
			biaya2: '',
			diskon: '',
			password: '',
			cpassword: '',
			mikrotikSelectedName: '',
			mikrotikSelected: '',
			mikrotikPilih: '',
			lat: '',
			lng: '',
			tanggal_register: '',

			modem: '',
			alamat: ''
		}
	},
	methods: {
		customFormatter (date) {
			return moment(date).format('DD');
		},
		getArea() {
			// for filter
			var data = new FormData();
			data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
			data.append('type', "all");
			data.append('bulan', "0");
			
			var apiUrl = inter.ListArea();
			this.PostData(data,apiUrl).then(x => {
				if (x.status) {
				this.area = x.data;
				} else {
				//alert(x.pesan);
				}
			})
		},
		getTarif() {
			this.isCari = false;

			var data = {
				token: 'TangTung '+sessionStorage.getItem('myToken')
			}
			
      		var apiUrl = inter.ListPaket();
			this.PostData(data,apiUrl).then(x => {
				if (x.status) {
				this.tarif = x.data;
				} else {
					//alert(x.pesan);
				}
			})
		},
		getMikrotik() {
			// for filter
            var data = {
                token: 'TangTung '+sessionStorage.getItem('myToken')
            }
			
			var apiUrl = inter.MiktorikList();
			this.PostData(data,apiUrl).then(x => {
				if (x.status) {
					this.mikrotik = x.data;
				} else {
				//alert(x.pesan);
				}
			})
		},
		DetailMikrotik() {
			this.isCari = false;

			var data = {
				token: 'TangTung '+sessionStorage.getItem('myToken'),
				id: this.mikrotikSelected
			}
			
      		var apiUrl = inter.MikrotikDetail();
			this.PostData(data,apiUrl).then(x => {
				if (x.status) {
					this.mikrotikSelectedName = x.data.nama;
				} else {
					//alert(x.pesan);
				}
			})
		},
        Simpan() {

			console.log("simpan");

			if (this.tanggal == "" || this.tanggal == "In") {
				alert("Tanggal Tagihan tidak boleh kosong");
				return false;
			}

			if (this.password.length > 0) {
				if (this.password != this.cpassword) {
					alert("Password tidak sama");
					return false;
				}
			}

			var data = new FormData();
            data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
            data.append('nama', this.nama);
            data.append('ppoe', this.ppoe);
            data.append('wa', this.wa);
			data.append('paket', this.tarifPilih);
			data.append('area', this.areaPilih);
			data.append('tanggal', moment(this.tanggal).format('DD'));
			data.append('userid', this.id);
			data.append('rincian1', this.rincian1);
			data.append('rincian2', this.rincian2);
			data.append('biaya1', this.biaya1);
			data.append('biaya2', this.biaya2);
			data.append('diskon', this.diskon);
			data.append('password', this.password);
			data.append('mikrotik', this.mikrotikPilih);
			data.append('lat', this.lat);
			data.append('lng', this.lng);
			data.append('tanggalReg', this.tanggal_register);
			data.append('alamat', this.alamat);
			data.append('modem', this.modem);
			
            var apiUrl = inter.PelangganEdit();

			myGlobal.loger(data);
            
			this.PostData(data,apiUrl).then(x => {
				this.loger(x);
				if (x.status) {
                    location.href="#/pelanggan";

					RedisSession.clearUser();

					//sessionStorage.removeItem("main-old_getData");
				} else {
				    alert(x.pesan);
				}
			})
        }
	},
	mounted() {
		this.getArea();
		this.getTarif();
		this.getMikrotik();

		//console.log(this.$route.params.nama);

		let parame = this.$route.params.nama;
		if(parame == null) {
			this.$router.go(-1);
			//alert("kok kosong");
		}

		this.id = this.$route.params.id;
		this.nama = this.$route.params.nama;
		this.wa = this.$route.params.wa;
		this.ppoe = this.$route.params.ppoe;
		this.tanggal = "2021-01-"+this.$route.params.tgl;
		this.areaPilih = this.$route.params.areaid;
		this.areaNama = this.$route.params.area;
		this.tarifPilih = this.$route.params.paketid;
		this.tarifNama = this.$route.params.paket;
		if (this.$route.params.rincian1 != null) {
			this.rincian1 = this.$route.params.rincian1;
		}
		if (this.$route.params.rincian2 != null) {
			this.rincian2 = this.$route.params.rincian2;
		}
		if (this.$route.params.biaya1 != null) {
			this.biaya1 = this.$route.params.biaya1;
		}
		if (this.$route.params.biaya2 != null) {
			this.biaya2 = this.$route.params.biaya2;
		}
		this.diskon = this.$route.params.diskon;
		this.mikrotikSelected = this.$route.params.mikrotikId;
		this.mikrotikPilih = this.$route.params.mikrotikId;
		this.lat = this.$route.params.lat;
		this.lng = this.$route.params.lng;
		this.tanggal_register = this.$route.params.tanggal_register;
		if (this.$route.params.alamat != null) {
			this.alamat = this.$route.params.alamat;
		}
		
		this.modem = (this.$route.params.modem_info != null ? this.$route.params.modem_info : '');

		// console.log(JSON.stringify(this.$route.params));

		this.DetailMikrotik();
	}
}
</script>

<style scoped>
.edit-input {
	font-size: 20pt !important;
}
.file-upload {
    opacity: 1 !important;
    position: relative !important;
    z-index: 0 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/pelanggan/edit.vue